import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormControl, Row} from 'react-bootstrap';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";
import {SbWebMap} from "../../SbMap";

@SurveyFormInputEnhance
export class SurveyFormInputWebMap extends PureComponent {
    @autobind
    change(e) {
        this.props.SurveyFormInput.Change((answer) => {
            const value = e.target.value;
            answer.valueText = value;

            return answer;
        });
    }

    render() {
        const answer = this.props.SurveyFormInput.GetAnswer();

        if(!this.props.EditMode) {
            if(answer && answer.valueText) {
                //8f74795367dc4029a80daef4aeaa996d
                return <Row>
                    <Col xs={12}>
                        <SbWebMap WebMapId={answer.valueText} />
                    </Col>
                </Row>;
            } else {
                return <span>No map selected</span>;
            }
        }

        return <FormControl className="sb-survey-form-input-text" as="textarea" value={answer ? (answer.valueText == null ? "" : answer.valueText): ""} onChange={this.change} />;
    }
}


